import { Box, Tooltip } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { RanaAlert, RanaAlertProps } from "@nens/ranalib";

import { descriptorIsLoading } from "@/utils/descriptor-is-loading";

import { AnyFile } from "../types/any-file";

export const descriptorToAlertStatus = (
  descriptor: AnyFile["descriptor"]
): RanaAlertProps["status"] => {
  if (descriptor === undefined) return "info";
  if (descriptorIsLoading(descriptor)) return "inProgress";
  const descriptorStatus = descriptor?.status;
  const statusId = typeof descriptorStatus === "string" ? descriptorStatus : descriptorStatus?.id;

  switch (statusId) {
    case undefined:
      return "inProgress";
    case "completed":
      return "success";
    case "retry":
      return "warning";
    case "failed":
      return "error";
    case "deleted":
      return "info";
    default:
      console.warn("Unhandled file descriptor status:", statusId);
      return "info";
  }
};

interface RanaFileStatusIconProps extends RanaAlertProps {
  file: AnyFile;
}

export const RanaFileStatusIcon = ({ file, ...rest }: RanaFileStatusIconProps) => {
  const status = descriptorToAlertStatus(file.descriptor);

  const descriptorStatus = file.descriptor?.status;
  const messageI18n =
    typeof descriptorStatus === "object" && "messageI18n" in descriptorStatus
      ? descriptorStatus.messageI18n
      : undefined;

  const InnerStatus = () => {
    return (
      <RanaAlert
        mr={2}
        display="inline-flex"
        {...rest}
        status={status}
        iconSize={rest.boxSize ?? 3}
        variant="icon-only"
      />
    );
  };

  if (status !== "error") return <InnerStatus />;

  return (
    <Tooltip
      label={
        messageI18n != null ? (
          <FormattedMessage
            id={messageI18n.type}
            defaultMessage={messageI18n.msg}
            values={messageI18n.ctx || {}}
          />
        ) : (
          <FormattedMessage
            id="filepreview.something_went_wrong"
            defaultMessage="Something went wrong with processing this file, preview is not available"
          />
        )
      }
    >
      <Box display="inline-flex" verticalAlign="middle" position="relative">
        <InnerStatus />
      </Box>
    </Tooltip>
  );
};
